import React from "react";
import "./App.css";

function clone(object) {
  return JSON.parse(JSON.stringify(object));
}

function DataSet(arrData) {
  this.data = {};
  this.pendingData = {};
  for (let i = 0; i < arrData.length; i++) {
    this.data["column" + i] = arrData[i];
  }
  this.pendingData = clone(this.data);
  this.colInx = arrData.length;
  this.rowCount = arrData[0].length;

  // avalable actions;
  this.selectCol = (keyArray) => {
    const newData = {};
    for (let i = 0; i < keyArray.length; i++) {
      const key = keyArray[i];
      if (this.pendingData[key]) {
        newData[key] = this.pendingData[key];
      }
    }
    this.pendingData = newData;
    return this;
  };

  this.addCol = (keyArray) => {
    const addKey = "column" + this.colInx;
    this.colInx++;
    this.pendingData[addKey] = [];
    for (let i = 0; i < this.rowCount; i++) {
      let val;
      for (let j = 0; j < keyArray.length; j++) {
        if (j === 0) {
          val = this.pendingData[keyArray[j]][i];
        } else {
          val = this.pendingData[keyArray[j]][i] + val;
        }
      }
      this.pendingData[addKey].push(val);
    }
    return this;
  };

  this.orderBy = (orderKey) => {
    const array = [];
    const keys = Object.keys(this.pendingData);
    const inx = keys.indexOf(orderKey);
    keys.map((key) => {
      const columnArr = this.pendingData[key];
      array.push([...columnArr]);
    });
    const sortMap = {};
    const targetArr = array[inx];

    targetArr.sort((x, y) => {
      const result = y - x;
      const posX = targetArr.indexOf(x);
      const poxY = targetArr.indexOf(y);
      sortMap[posX + "_" + poxY] = result;
      return result;
    });

    for (let i = 0; i < array.length; i++) {
      if (i !== inx) {
        const currentArr = array[i];
        currentArr.sort((x, y) => {
          const posX = currentArr.indexOf(x);
          const poxY = currentArr.indexOf(y);
          return sortMap[posX + "_" + poxY];
        });
      }
    }

    for (let i = 0; i < array.length; i++) {
      this.pendingData[keys[i]] = array[i];
    }
  };

  return this;
}

const defaultArr = [
  [1, 3, 5, 7, 9, 11],
  [2, 4, 6, 8, 12, 10],
  [1, 2, 3, 4, 5, 6],
  [6, 5, 4, 3, 2, 1],
  ["name1", "name2", "name3", "name4", "name5", "name6"],
  [15, 15, 16, 16, 17, 17],
];

function App() {
  const [orgData, setOrgData] = React.useState(new DataSet(defaultArr));
  const [, forceUpdate] = React.useState();
  const [pendingFun, setPendingFun] = React.useState(
    "dataSet.orderBy('column1')"
  );
  const renderArr = (data) => {
    const keys = Object.keys(data);
    const columnCount = keys.length;
    const rowCount = data && keys && keys.length > 0 ? data[keys[0]].length : 0;
    const rows = [];
    let i = 0;
    const len = rowCount;
    while (i < len) {
      rows.push(i);
      i++;
    }

    return (
      <div className="arrWrap">
        <div className="arrHeaderWrap">
          {keys.map((key) => {
            return (
              <div className="arrHeaderItem" key={key}>
                {key}
              </div>
            );
          })}
        </div>
        <div className="arrContentWrap">
          {rows.map((inx) => {
            const columns = [];
            let i = 0;
            const len = columnCount;
            while (i < len) {
              columns.push(i);
              i++;
            }
            return (
              <div className="arrContentRowItem" key={"row" + inx}>
                {columns.map((column) => {
                  return (
                    <div className="arrContentColItem" key={column}>
                      {data[keys[column]][inx]}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const onClickRun = () => {
    (function () {
      try {
        const dataSet = orgData;
        eval(pendingFun);
      } catch (e) {
        alert(e.stack);
      }
    })();
    forceUpdate({});
  };

  return (
    <div className="App">
      <div className="wrap">
        <div className="orgWrap">{renderArr(orgData.data)}</div>
        <div className="actionWrap">
          <div>
            <button
              className="actionBtn"
              onClick={() => {
                setPendingFun("dataSet.orderBy('column1');");
              }}
            >
              Order By
            </button>

            <button
              className="actionBtn"
              onClick={() => {
                setPendingFun("dataSet.addCol(['column1','column2']);");
              }}
            >
              Add
            </button>

            <button
              className="actionBtn"
              onClick={() => {
                setPendingFun("dataSet.selectCol(['column1','column6']);");
              }}
            >
              Select
            </button>

            <button
              className="actionBtn"
              onClick={() => {
                setPendingFun(
                  "dataSet.addCol(['column0','column1','column2']);\ndataSet.selectCol(['column0','column6']);\n"
                );
              }}
            >
              Mutiple Action
            </button>
          </div>
          <textarea
            onChange={(e) => {
              setPendingFun(e.target.value);
            }}
            className="funArea"
            value={pendingFun}
          ></textarea>
          <button className="runBtn" onClick={onClickRun}>
            Run
          </button>
          <button
            className="runBtn"
            onClick={() => {
              orgData.pendingData = clone(orgData.data);
              forceUpdate({});
            }}
          >
            Reset
          </button>
        </div>
        <div className="targetWrap">{renderArr(orgData.pendingData)}</div>
      </div>

      <div className="role">
        <h3 style={{ textAlign: "left" }}>实现逻辑</h3>
        <ul style={{ textAlign: "left" }}>
          <li>
            1, 定义构建函数function DataSet(arrData),
            实现数据库数据（二维数组）到JS对象的转换
          </li>
          <li>
            2, 实现预先设置好的方法，比如 selectCol(), addCol(), orderBy()等
          </li>
          <li>
            3,
            用户或者前线工作人员，自定义数据操作时只需要直接调用预设方法，不需要写复杂的数据库语句，也不需要解析，比如
            <pre className="pre">
              dataSet.selectCol(['column0','column1']);
              dataSet.addCol(['column0','column1']); dataSet.orderBy('column0');
            </pre>
          </li>
        </ul>
        <h4 style={{ textAlign: "left" }}>DataSet 实现</h4>
        <div style={{ textAlign: "left" }}>
          <pre>
            {`
             function DataSet(arrData) {
                this.data = {};
                this.pendingData = {};
                for (let i = 0; i < arrData.length; i++) {
                  this.data["column" + i] = arrData[i];
                }
                this.pendingData = clone(this.data);
                this.colInx = arrData.length;
                this.rowCount = arrData[0].length;


                // avalable actions;

                this.selectCol = (keyArray) => {
                  const newData = {};
                  for (let i = 0; i < keyArray.length; i++) {
                    const key = keyArray[i];
                    if (this.pendingData[key]) {
                      newData[key] = this.pendingData[key];
                    }
                  }
                  this.pendingData = newData;
                  return this;
                };

                this.addCol = (keyArray) => {
                  const addKey = "column" + this.colInx;
                  this.colInx++;
                  this.pendingData[addKey] = [];
                  for (let i = 0; i < this.rowCount; i++) {
                    let val;
                    for (let j = 0; j < keyArray.length; j++) {
                      if (j === 0) {
                        val = this.pendingData[keyArray[j]][i];
                      } else {
                        val = this.pendingData[keyArray[j]][i] + val;
                      }
                    }
                    this.pendingData[addKey].push(val);
                  }
                  return this;
                };

                this.orderBy = (orderKey) => {
                  ...
                };

                return this;
              }
              `}
          </pre>
        </div>
      </div>
    </div>
  );
}

export default App;
